module.exports = __webpack_public_path__ + "static/assets/89927eefbe18af5b442019305a78cbb5.svg";